export const STATS = {
    all: {
        families: 4,
        raised: 705500000,
        exited: 508500000,
        aum: 197000000,
    },
};
